import AffectationPostePeseeController from './affectation.poste.pesee.controller';

export default {
    template: require('./affectation.poste.pesee.html'),
    controller: AffectationPostePeseeController
};
